import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export function useQISUGLastQuestions(
  courseId: number,
  subjectId: number,
  excludeId: number,
  iso?: string,
): {
  lastQuestions: QuestionIndexing.UsQiQuestion[];
  lastQuestionsLoading: boolean;
  lastQuestionsError: any;
} {
  const shouldFetch = !!courseId && !!iso && !!excludeId && !!subjectId;

  const { data, error, isLoading, isRefetching } = useQuery({
    queryKey: ["qi sug last questions", [courseId, iso, excludeId, subjectId]],
    queryFn: () =>
      fetchLastQuestions(courseId, {
        subjectId,
        excludeId,
        lang: iso,
      }),
    enabled: shouldFetch,
  });

  return {
    lastQuestions: data?.results,
    lastQuestionsLoading: isLoading || isRefetching,
    lastQuestionsError: error,
  };
}

function fetchLastQuestions(courseId: number, params: any) {
  return axios
    .get(`/api/questions/sugLastQuestions/${courseId}/`, {
      params,
    })
    .then((response) => response.data);
}
